// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2t81f","right":"styles_right__160It"};